define('modules/common/filter/curia',[], function() {
	var Filter = function($filter) {

		return function(curia) {
			if (curia) {
				var result = [];
				result.push(curia.descrizione + " di " + curia.sede);
				if (curia.sezionedistaccata) {
					result.push("sez. dist. di " + curia.sezionedistaccata);
				}
				if (curia.sezione) {
					result.push("sezione " + curia.sezione);
				}
				return result.join(" ");
			} else {
				return "";
			}

		};

	};
	return ["$filter", Filter];
});
